import { UsersError } from '@/lib/Errors';
import _axios from '@/plugins/axios';
export default {
	async getPCCFacilities (pccOrgId) {
		const response = await _axios.get('/pcc/getpccfacilities/', { params: { pccOrgId } });
		if (response.data.resFlag) {
			return response.data;
		}
		throw new UsersError('Error getting PointClickCare Facilities');
	},
	async getMappedPccResidentsForHospital (hospitalId) {
		const response = await _axios.get('/pcc/getmappedpccresidentsforhospital', { headers: { hospitalId: hospitalId } });
		if (response.data.resFlag) {
			return response.data;
		}
		throw new UsersError('Error getting PointClickCare Facilities');
	},
	async getPCCFacilityById (pccOrgId, facilitiesById) {
		const response = await _axios.get('/pcc/getfacilitiesbyid/', { params: { pccOrgId, facilitiesById } });
		if (response.data.resFlag) {
			return response.data;
		}
		throw new UsersError('Error getting PointClickCare Facilities by id');
	},
	async getFacilitiesById (pccOrgId, facilitiesById) {
		const response = await _axios.get('/pcc/getfacilitiesbyid/', {
			params: { pccorgid: pccOrgId, facilitiesbyid: facilitiesById },
		});
		if (response.data.resFlag) {
			return response.data;
		}
		throw new UsersError('Error getting PointClickCare Facilities by id');
	},
	async getPCCPatients (pccOrgId, pccFacilityId) {
		const response = await _axios.get('/pcc/getPCCPatients/', { params: { pccOrgId, pccFacilityId } });
		if (response.data.resFlag) {
			return response.data;
		}
		throw new UsersError('Error getting PointClickCare Patients by facility id');
	},
	async getPatientById (pccOrgId, pccPatientId) {
		const response = await _axios.get('/pcc/getPatientById/', { params: { pccOrgId, pccPatientId } });
		if (response.data.resFlag) {
			return response.data;
		}
		throw new UsersError('Error getting PointClickCare Patients by id');
	},
	async getPractitioners (pccOrgId, pccPatientId, locationId) {
		const response = await _axios.get('/pcc/getPractitioners/', { params: { pccOrgId, pccPatientId, locationId } });
		if (response.data.resFlag) {
			return response.data;
		}
		throw new UsersError('Error getting PointClickCare Practitioners by patient id');
	},
	async getObservations (pccOrgId, pccPatientId) {
		const response = await _axios.get('/pcc/getObservations/', { params: { pccOrgId, pccPatientId } });
		if (response.data.resFlag) {
			return response.data;
		}
		throw new UsersError('Error getting PointClickCare Observations by patient id');
	},
	async getMedications (pccOrgId, pccFacilityId, pccPatientId) {
		const response = await _axios.get('/pcc/getMedications/', { params: { pccOrgId, pccFacilityId, pccPatientId } });
		if (response.data.resFlag) {
			return response.data;
		}
		throw new UsersError('Error getting PointClickCare Medications by patient id');
	},
	async getConditions (pccOrgId, pccPatientId) {
		const response = await _axios.get('/pcc/getConditions/', { params: { pccOrgId, pccPatientId } });
		if (response.data.resFlag) {
			return response.data;
		}
		throw new UsersError('Error getting PointClickCare Conditions by patient id');
	},
	async getAssessments (pccOrgId, pccPatientId) {
		const response = await _axios.get('/pcc/getAssessments/', { params: { pccOrgId, pccPatientId } });
		if (response.data.resFlag) {
			return response.data;
		}
		throw new UsersError('Error getting PointClickCare Assessments by patient id');
	},
	async createPCCLocationMappingAndLocation (pccLocation) {
		const response = await _axios.post('/pcc/pccLocationCreateMappingAndLocation', pccLocation);
		if (response.data.resFlag) {
			return response.data;
		}
		throw new UsersError('Error creating PointClickCare location mapping and location');
	},
	async updatePCCLocationMapping (id, pccLocation) {
		const response = await _axios.put(`/pcc/pccLocationUpdateMapping/${id}`, pccLocation);
		if (response.data.resFlag) {
			return response.data;
		}
		throw new UsersError('Error updating PointClickCare location mapping');
	},
	async deletePCCLocationMapping (id) {
		const response = await _axios.delete(`/pcc/pccLocationDeleteMapping/${id}`);
		if (response.data.resFlag) {
			return response.data;
		}
		throw new UsersError('Error deleting PointClickCare location mapping');
	},
	async getMappedPccLocations () {
		const response = await _axios.get('/pcc/getmappedpcclocations');
		if (response.data.resFlag) {
			return response.data;
		}
		throw new UsersError('Error getting PointClickCare location mapping');
	},
	async pccLocationDeleteMapping (id) {
		const response = await _axios.delete(`/pcc/pcclocationdeletemapping/${id}`);
		if (response.data.resFlag) {
			return response.data;
		}
		throw new UsersError('Error deleting PointClickCare location mapping');
	},

	async getMappedPccOrganizations () {
		const response = await _axios.get('pcc/getmappedpccorganizations');
		if (response.data?.resFlag) {
			const userJson = response.data.data;
			return userJson;
		} else {
			throw new UsersError('Error getting mapped PCC Organizations');
		}
	},

	async addPccMapForCompany (body) {
		const response = await _axios.post('pcc/addpccmapforcompany', body);
		if (response.data.resFlag) {
			return response.data;
		}
		throw new UsersError(response.data.msg);
	},

	async editPccMapForCompany (body) {
		const { id, ...bodyRemaining } = body;
		const response = await _axios.put(`pcc/updatepccmapforcompany/${id}`, bodyRemaining);
		if (response.data.resFlag) {
			return response.data;
		}
		throw new Error(response.data.msg);
	},

	async deletePccMapForCompany (id) {
		const response = await _axios.delete(`pcc/deletepccmapforcompany/${id}`);
		if (response.data.resFlag) {
			return response.data;
		}
		throw new Error(response.data.msg);
	},

	async deleteMappedUser (id) {
		const response = await _axios.delete(`pcc/deletepccmappeduser/${id}`);
		if (response.data.resFlag) {
			const userJson = response.data.data;
			return userJson;
		} else {
			throw new UsersError('Invalid id');
		}
	},

	async addMappedPccUser (body) {
		const response = await _axios.post('pcc/addmappedpccuser', body);
		if (response.data.resFlag) {
			return response.data;
		}
		throw new Error(response.data.msg);
	},

	async getPccRateLimits () {
		try {
			const response = await _axios.get('pcc/getpccratelimits');
			if (response.data.statusCode === 200 && response.data.resFlag) {
				const rateLimits = response.data.data;
				if (!rateLimits) return;
				let isPCCDisabled = null;
				rateLimits.dailyPercentage = rateLimits.dailyRemaining / rateLimits.dailyLimit;
				rateLimits.minutePercentage = rateLimits.minuteRemaining / rateLimits.minuteLimit;
				if (rateLimits.dailyPercentage <= 0.1) {
					isPCCDisabled = true;
					rateLimits.severity = 'critical';
					rateLimits.text = 'shutting-off-due-to-exhausted-daily-pcc-calls';
					setTimeout(() => (isPCCDisabled = false), new Date(rateLimits.dailyResetAt).getTime() - new Date().getTime());
				} else if (rateLimits.minutePercentage <= 0.05) {
					isPCCDisabled = true;
					const now = Date.now();
					const nextMinute = Math.ceil(now / 60000) * 60000;
					const delay = Math.max(0, nextMinute - now);
					setTimeout(() => (isPCCDisabled = false), delay);
					rateLimits.severity = 'critical';
					rateLimits.text = 'shutting-off-due-to-exhausted-minute-pcc-calls-please-wait';
				} else if (rateLimits.dailyPercentage < 0.3 && rateLimits.dailyPercentage >= 0.2) {
					rateLimits.severity = 'warning';
					rateLimits.text = 'quarter-of-daily-pcc-calls-remaining';
				} else {
					isPCCDisabled = false;
					return {
						rateLimits: rateLimits,
						isPCCDisabled,
					};
				}

				const rateLimitsToBePushedNotifications = {
					...rateLimits,
					type: 'static',
					name: 'pcc-rate-limit',
					createdAt: new Date(),
				};
				return {
					rateLimits: rateLimitsToBePushedNotifications,
					isPCCDisabled,
				};
			} else {
				return response.data;
			}
		} catch (error) {
			return error.response.data;
		}
	},
	async getMyPCCOrganizations () {
		const response = await _axios.get('/pcc/getMyPCCOrganizations/');
		if (response.data.resFlag) {
			return response.data;
		}
		throw new UsersError('Error getting PointClickCare Organizations');
	},
};
